module.exports = __webpack_public_path__ + "static/media/super_pack_fr_ete_chat.9359bbac.png";